(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('hiddenContent', function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            open: '@',
            showMoreText: '@',
            showLessText: '@',
            hideable: '@'
        },
        templateUrl: 'partials/home/directivetemplate?type=HiddenContent',
        link(scope) {
            scope.more = function(e) {
                e.preventDefault();
                scope.showMore = true;
            };

            scope.less = function(e) {
                e.preventDefault();
                scope.showMore = false;
            };

            scope.showMore = scope.open === 'true';
        }
    };
});
})();
